import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { userService } from "services";
import { uiActions } from "store";

const useCheckCredentialsMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ username, password }) => {
			return userService.checkCredentials({ username, password });
		},
		{
			onError(error) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useCheckCredentialsMutation;
